import React from "react";
import { Marker, Tooltip, Popup } from "react-leaflet";
import L from "leaflet";

const speedColor = (s) => (s >= 20 ? "#E63946" : s >= 10 ? "#F2542D" : "#8FA99B");

function arrowIcon(dirDeg, speed) {
  // dir_deg = direction wind comes FROM; arrow points downwind
  const rot = ((dirDeg || 0) + 180) % 360;
  const color = speedColor(speed || 0);
  return L.divIcon({
    className: "wind-arrow-marker",
    html: `<div style="display:flex;flex-direction:column;align-items:center;">
      <svg width="26" height="26" viewBox="0 0 24 24" style="transform: rotate(${rot}deg); filter: drop-shadow(0 1px 1px rgba(0,0,0,0.7));">
        <path d="M12 2 L17 12 L13.5 10.8 L13.5 22 L10.5 22 L10.5 10.8 L7 12 Z" fill="${color}" stroke="#0A0D0C" stroke-width="1"/>
      </svg>
      <span style="font: bold 9px monospace; color:${color}; text-shadow: 0 1px 2px #000;">${Math.round(speed || 0)}</span>
    </div>`,
    iconSize: [26, 36],
    iconAnchor: [13, 18],
  });
}

const dirLabel = (d) => {
  if (d == null) return "";
  const dirs = ["N", "NE", "E", "SE", "S", "SW", "W", "NW"];
  return dirs[Math.round(d / 45) % 8];
};

export default function WindLayer({ points = [] }) {
  return points
    .filter((p) => p.lat != null && p.speed_mph != null)
    .map((p, i) => (
      <Marker
        key={`wind-${p.station || i}`}
        position={[p.lat, p.lon]}
        icon={arrowIcon(p.dir_deg, p.speed_mph)}
        zIndexOffset={400}
        interactive={true}
      >
        <Tooltip direction="top" offset={[0, -14]}>
          <span className="font-mono-tac text-[11px]">
            {dirLabel(p.dir_deg)} {Math.round(p.speed_mph)} mph
            {p.gust_mph ? ` · gusts ${Math.round(p.gust_mph)}` : ""}
          </span>
        </Tooltip>
        <Popup autoClose={false} closeOnClick={false} offset={[0, -12]}>
          <div className="min-w-[150px]" data-testid={`wind-popup-${p.station || i}`}>
            <div className="text-[10px] font-bold uppercase tracking-wider text-tac-dim mb-1">
              Wind · {p.station || "Station"}
            </div>
            <div className="text-[15px] font-bold font-mono-tac" style={{ color: speedColor(p.speed_mph || 0) }}>
              {dirLabel(p.dir_deg)} {Math.round(p.speed_mph)} mph
            </div>
            {p.gust_mph != null && (
              <div className="text-[12px] font-mono-tac text-tac-dim">gusts {Math.round(p.gust_mph)} mph</div>
            )}
            {p.dir_deg != null && (
              <div className="text-[11px] font-mono-tac text-tac-faint mt-0.5">
                blowing from {Math.round(p.dir_deg)}°
              </div>
            )}
            {p.at && (
              <div className="text-[10px] font-mono-tac text-tac-faint mt-1 pt-1 border-t border-tac-border/60">
                observed {new Date(p.at).toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" })}
              </div>
            )}
          </div>
        </Popup>
      </Marker>
    ));
}
